import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Stack, Box, useTheme, useMediaQuery } from "@mui/material";
import IncomingCallCard from "./IncomingCallCard";
import { selectIncomingCalls } from "../../../state/userAgent/userAgentSlice";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";
import { acceptCallAction } from "../../../sagas/userAgent/acceptCall/action";
import { ignoreCallAction } from "../../../sagas/userAgent/ignoreCall/action";
import { rejectCallAction } from "../../../sagas/userAgent/rejectCall/action";

const IncomingCallsContainer = ({ appBarHeight }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const incomingCalls = useSelector(selectIncomingCalls);
  const { defaultCrm } = useSelector(selectUserCredentials);
  const [minimizedCalls, setMinimizedCalls] = useState({});
  const drawerWidth = isMobile ? 0 : 220;
  const incomingCallOffset = isMobile ? 80 : 300;

  const handleAnswer = (callSession) => {
    dispatch(acceptCallAction(callSession));
  };

  const handleIgnore = (callSession) => {
    dispatch(ignoreCallAction(callSession));
  };

  const handleReject = (callSession) => {
    dispatch(rejectCallAction(callSession));
  };

  const handleMinimize = (callId) => {
    setMinimizedCalls((prev) => ({
      ...prev,
      [callId]: !prev[callId],
    }));
  };

  if (incomingCalls.length === 0) return null;

  return (
    <React.Fragment>
      <Stack
        spacing={2}
        sx={{
          position: "fixed",
          top: `${appBarHeight + 300}px`,
          left: `${drawerWidth + incomingCallOffset}px`,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        {incomingCalls.map(
          (call) =>
            !minimizedCalls[call.id] && (
              <IncomingCallCard
                key={call.id}
                callSession={call}
                onAnswer={handleAnswer}
                onIgnore={handleIgnore}
                onReject={handleReject}
                onMinimize={() => handleMinimize(call.id)}
                isMinimized={false}
                crmContact={call.crmContact}
                crmType={defaultCrm}
              />
            )
        )}
      </Stack>

      <Stack
        spacing={2}
        sx={{
          position: "fixed",
          bottom: 90,
          right: 20,
          maxWidth: 400,
          maxHeight: "80vh",
        }}
      >
        {incomingCalls.map(
          (call) =>
            minimizedCalls[call.id] && (
              <IncomingCallCard
                key={call.id}
                callSession={call}
                onAnswer={handleAnswer}
                onIgnore={handleIgnore}
                onReject={handleReject}
                onMinimize={() => handleMinimize(call.id)}
                isMinimized={true}
              />
            )
        )}
      </Stack>
    </React.Fragment>
  );
};

export default IncomingCallsContainer;
